import styled from "styled-components";
import { NEUTRAL_200 } from "../constants/colours";

export const AssessmentNote = styled.div`
   background-color:${NEUTRAL_200};
   padding: 2px 16px;
   box-sizing: border-box;
   border-radius: 8px;
`;